import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { SharedService } from '../../services/shared.service'
import { HttpService } from '../../services/http.service'
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component'
import { SpinnerDialogComponent } from '../../dialogs/spinner-dialog/spinner-dialog.component'
import {InvalidTicketDialogComponent} from "../../dialogs/invalid-ticket-dialog/invalid-ticket-dialog.component";

@Component({
	selector: 'app-imei',
	templateUrl: './imei.component.html',
	styleUrls: ['./imei.component.css']
})
export class ImeiComponent {
	isRecaptchaSuccess: boolean
	isRecaptcharRestart: boolean = false
	siteKey: string
	form: FormGroup
	spinner: MatDialogRef<SpinnerDialogComponent>

	constructor(
		private router: Router,
		private shared: SharedService,
		private http: HttpService,
		private formBuilder: FormBuilder,
		private dialog: MatDialog,
	) {
		this.shared.blockRefresh()
		this.siteKey = this.shared.recaptchaSiteKey
		this.isRecaptchaSuccess = this.shared.isRecaptchaSuccess
		this.form = this.formBuilder.group({
			modelCode: [
				this.shared.modelCode,
				Validators.required
			],
			serialNumber: [
				this.shared.serialNumber,[
					Validators.required,
					Validators.pattern(/^([A-Za-z0-9]{0,})$/),
					Validators.minLength(15),
					Validators.maxLength(15)
				]
			],
			recaptcha: [
				'',
				Validators.required
			],
      ticketNo: [
        this.shared.ticketNo,[
          Validators.pattern(/^\d{10}$/),
          Validators.minLength(10),
          Validators.maxLength(10)
        ]
      ],
		})
	}

	keyPressAlphaNumericOnly(event: any) {
		this.shared.keyPressAlphaNumericOnly(event)
	}

	onRecatcharSuccess(e: any): void {
		this.isRecaptchaSuccess = true
	}

	onRecaptchaExpired(): void {
		this.isRecaptcharRestart = true
		let interval = setInterval(() => {
			this.isRecaptchaSuccess = false
			this.isRecaptcharRestart = false
			clearInterval(interval)
		}, 100)
	}

  showTicketInfo(): void {
    this.dialog.open(MessageDialogComponent, {
      data: {
        title: 'Technician Promotion',
        description: 'You are eligible for a $10 by entering the 10 digits <b>Ticket No.</b> provided by the technician',
        button: 'OK'
      }
    });
  }

	onNext(): void {
    this.isRecaptchaSuccess = true;
		if (this.isRecaptchaSuccess) {
			const modelCode = <string>this.form.value.modelCode.toUpperCase()
			const serialNumber = <string>this.form.value.serialNumber.toUpperCase()
			const ticketNo = <string>this.form.value.ticketNo
			this.spinner = this.dialog.open(SpinnerDialogComponent, {
				panelClass: 'transparent',
				disableClose: true
			})
			this.http.getProducts(modelCode, serialNumber, this.shared.agentId, this.shared.storename, ticketNo)
				.subscribe((response) => {
					console.log(response)
					this.spinner.close()
					if (response.success) {
						this.shared.modelCode = modelCode
						this.shared.serialNumber = serialNumber
            this.shared.ticketNo = ticketNo
            const technicianId = response.data[0]?.TECHNICIANID;
            if(ticketNo && (!technicianId || technicianId === '')) {
              this.dialog.open(InvalidTicketDialogComponent, {
                data: {
                  title: 'Invalid Ticket No.',
                  description: 'Would you like to proceed without Ticket No?',
                  button: 'Close'
                }
              });
            } else {
              this.router.navigateByUrl('/product')
            }
					} else {
						this.dialog.open(
							MessageDialogComponent, {
							data: {
								title: '',
								description: response.meta.error_message,
								button: 'Close'
							}
						})
					}
					this.shared.products = response.data

				}, (error) => {
					this.spinner.close()
					this.dialog.open(
						MessageDialogComponent, {
						data: {
							title: '',
							description: error.message,
							button: 'Close'
						}
					})
				})
		}
	}
}
